import { IRootState } from '../../../store'
import { IDriversLicenseScannerState } from '../store/driversLicenseScanner.types'

export const getDriversLicenseScannerSelector = (state: IRootState): IDriversLicenseScannerState => state.dlScanner
